// Leaf-модуль без импортов (как session_events): мост между сетевым слоем
// и приложением для сигналов «сеть деградировала» / «сеть восстановилась».
// useApiRequest ловит SmartFetchError (ttfb/overall/network) — тихий дроп на
// пути (РКН-кейс), таймаут TTFB/total, или сетевая ошибка при формально
// online-браузере — и эмитит degraded. Любой успешный ответ эмитит recovered.
// Обработчик (entrypoints/application.ts → network_toast) держит залипший тост
// «Сеть недоступна» и снимает его при восстановлении. Это НЕ offline: офлайн
// (navigator.onLine === false) покрывает OfflineBanner; здесь — деградация при
// живом соединении.

import type { SmartFetchAbortReason } from '@/services/network/smart_fetch'

export type NetworkDegradedReason = Exclude<SmartFetchAbortReason, 'user'>

type NetworkDegradedHandler = (reason: NetworkDegradedReason) => void
type NetworkRecoveredHandler = () => void

let degradedHandler: NetworkDegradedHandler | null = null
let recoveredHandler: NetworkRecoveredHandler | null = null

export function onNetworkDegraded(h: NetworkDegradedHandler): void {
  degradedHandler = h
}

export function onNetworkRecovered(h: NetworkRecoveredHandler): void {
  recoveredHandler = h
}

// Вызывается из useApiRequest при сетевой деградации. Идемпотентно по
// дизайну: много параллельных запросов могут позвать — обработчик сам
// решает, показывать ли тост заново.
export function emitNetworkDegraded(reason: NetworkDegradedReason): void {
  degradedHandler?.(reason)
}

// Вызывается из useApiRequest на любом успешном ответе — сервер снова отвечает,
// деградация закончилась. Идемпотентно: каждый успешный запрос зовёт, обработчик
// сам понимает, висит ли тост.
export function emitNetworkRecovered(): void {
  recoveredHandler?.()
}
